import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { getEditorScrollStyles } from '../../styles';
import { StyleColor, NewStyleColor, macTopBarHeight } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';
import UserAgentUtils from '../../../../utils/userAgent';

interface ButtonCombineProps {
	disabled: boolean;
}

const Wrapper = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 11;
	display: flex;
	flex-direction: column;
	background-color: ${NewStyleColor.Black};
`;

const Header = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	flex: 0 0 50px;
	padding: 0 12px;
	border-bottom: 1px solid ${hexToRgba(StyleColor.Grey450, 50)};

	${UserAgentUtils.isMacApp() && `padding-top: ${macTopBarHeight};`}
`;

const Body = styled('div')`
	position: relative;
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	overflow-y: auto;

	${getEditorScrollStyles()}
`;

const Footer = styled('div')`
	flex: 0 0 50px;
	display: flex;
	justify-content: flex-end;
	padding: 0 20px;
	background-color: ${NewStyleColor.Grey900};
`;

const Title = styled(Translate)`
	margin-left: 6px;
	margin-right: auto;
	padding-right: 6px;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 600;
	font-size: 15px;
	line-height: 20px;
	color: ${NewStyleColor.White};
`;

const ButtonCombine = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 30px;
	margin-left: 10px;
	padding: 5px 20px;
	border: 0;
	border-radius: 15px;
	outline: 0;
	background-color: ${NewStyleColor.Blue450};
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: 19px;
	color: ${NewStyleColor.White};
	cursor: pointer;
	white-space: nowrap;

	${({ disabled }: ButtonCombineProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}
`;

const ButtonSelectAll = styled('button').attrs({
	type: 'button',
})`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 90px;
	width: 90px;
	min-width: 82px;
	height: 35px;
	padding: 7px;
	border: 0;
	border-radius: 6px;
	outline: 0;
	background-color: ${hexToRgba(NewStyleColor.White, 12)};
	color: ${({ color }) => color || NewStyleColor.White};
	cursor: pointer;
	margin-right: 6px;

	& + & {
		margin-right: 6px;
	}
`;

const Loader = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${hexToRgba(NewStyleColor.Black, 75)};
	font-weight: bold;
	font-size: 21px;
	color: ${NewStyleColor.White};
`;

export {
	Wrapper,
	Header,
	Body,
	Footer,
	Title,
	ButtonCombine,
	ButtonSelectAll,
	Loader,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/SpreadsSelector/styles.ts